import { ArrowRight, MessageCircle } from "lucide-react";
import { Reveal } from "./motion";
import Marquee from "./Marquee";
import { FINAL_CTA } from "../config/content";
import { genericWhatsAppLink } from "../lib/api";

export default function FinalCta({ onBook }) {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden" data-testid="final-cta-section">
      <div className="absolute inset-0 flex items-center opacity-60 pointer-events-none" aria-hidden="true">
        <Marquee faint />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-[#070A08] via-[#070A08]/70 to-[#070A08] pointer-events-none" aria-hidden="true" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] bg-[#22C55E]/[0.12] blur-[120px] rounded-full pointer-events-none" aria-hidden="true" />
      <div className="relative max-w-[900px] mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <Reveal>
          <h2 className="font-heading uppercase text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-wide" data-testid="final-cta-heading">
            {FINAL_CTA.titleA}
            <br />
            <span className="text-[#22C55E]">{FINAL_CTA.titleHighlight}</span>
          </h2>
          <p className="mt-6 text-base sm:text-lg text-[#A7B3AA] leading-relaxed max-w-2xl mx-auto" data-testid="final-cta-text">{FINAL_CTA.text}</p>
          <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={onBook}
              data-testid="final-cta-book-button"
              className="btn-primary group relative inline-flex items-center gap-3 rounded-full bg-[#22C55E] hover:bg-[#16A34A] text-[#04100A] font-extrabold text-base sm:text-lg px-8 py-4 transition-colors overflow-hidden w-full sm:w-auto justify-center"
            >
              <span className="relative z-10">{FINAL_CTA.primary}</span>
              <ArrowRight className="w-5 h-5 relative z-10 arrow-slide" />
              <span className="shine" aria-hidden="true" />
            </button>
            <a
              href={genericWhatsAppLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="final-cta-whatsapp-button"
              className="inline-flex items-center justify-center gap-2.5 rounded-full border border-[#22C55E]/40 text-white font-bold text-base px-8 py-4 hover:bg-[#22C55E]/10 hover:border-[#22C55E]/70 transition-colors w-full sm:w-auto"
            >
              <MessageCircle className="w-5 h-5 text-[#22C55E]" />
              {FINAL_CTA.secondary}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
